import { Col, Image, Row, Typography, Button, Space, Tooltip } from 'antd'
// import React, { useEffect, useState } from 'react'
import { QuestionCircleOutlined, BugFilled, HistoryOutlined, RocketOutlined } from '@ant-design/icons';
import LanguageDropdown from './LanguageDropdown';
import { RefLanguage } from '../hooks/LanguageHooks';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import * as con from '../Constants';

const { Text } = Typography;

function Header({ onStartTour, onModeToggle, isNewAnalysisMode, showModeToggle }) {
    const i18n = RefLanguage();
    const navigate = RefSetCurrentPage();
    
    const handleBugReportClick = () => {
        navigate(con.PAGE_BUG_REPORT);
    };

    const handleModeToggleClick = () => {
        if (onModeToggle) {
            onModeToggle();
        }
    };
    
    const headerButtonStyle = {
        backgroundColor: "transparent",
        border: "none",
        color: "var(--text-color-1)",
        borderRadius: "8px",
        width: "5vh",
        height: "5vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "2.4vh",
        transition: "all 0.3s ease",
        padding: "0"
    };

    return (
        <Row className='header' align="middle" justify="space-between">
            <Col span={4} style={{ display: "flex", alignItems: "center" }}>
                <div style={{ padding: "1vh", paddingLeft: "4vh" }}>
                    <Image
                        width={"7vh"}
                        src="eukaryome-logo.png"
                        alt="logo"
                        preview={false}
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(con.PAGE_HOME)}
                    />
                </div>
            </Col>
            <Col span={16} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <a 
                    href="https://eukaryome.org/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ 
                        textDecoration: "none", 
                        color: "inherit",
                        cursor: "pointer"
                    }}
                >
                    <Text style={{ color: "var(--text-color-1)", fontSize: "6vh", fontWeight: 'bold' }}>EUKARYOME</Text>
                </a>
            </Col>
            <Col span={4} style={{ paddingRight: "20px", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                <Space size="middle">
                    {showModeToggle && (
                        <Tooltip 
                            title={isNewAnalysisMode ? i18n.t('headerShowHistoric') || 'View Historic Results' : i18n.t('headerNewAnalysis') || 'New Analysis'} 
                            placement="bottom"
                        >
                            <Button 
                                className="header-button"
                                style={headerButtonStyle}
                                onClick={handleModeToggleClick}
                                data-tour="historic-results"
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                                    e.target.style.transform = "scale(1.1)";
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.transform = "scale(1)";
                                }}
                            >
                                {isNewAnalysisMode ? <HistoryOutlined /> : <RocketOutlined />}
                            </Button>
                        </Tooltip>
                    )}
                    <Tooltip title={i18n.t('headerGuidedTour')} placement="bottom">
                        <Button 
                            className="header-button"
                            style={headerButtonStyle}
                            onClick={onStartTour}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                                e.target.style.transform = "scale(1.1)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "transparent";
                                e.target.style.transform = "scale(1)";
                            }}
                        >
                            <QuestionCircleOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title={i18n.t('headerReportBug')} placement="bottom">
                        <Button 
                            className="header-button"
                            style={headerButtonStyle}
                            onClick={handleBugReportClick}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                                e.target.style.transform = "scale(1.1)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "transparent";
                                e.target.style.transform = "scale(1)";
                            }}
                        >
                            <BugFilled />
                        </Button>
                    </Tooltip>
                    <LanguageDropdown />
                </Space>
            </Col>
        </Row>
    )
}

export default Header
